import React, { useState, useEffect } from 'react';
import { Box, Paper, Typography, Grid } from '@mui/material';
import DateRangeIcon from '@mui/icons-material/DateRange';
import EventSeatIcon from '@mui/icons-material/EventSeat';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { useSearchParams } from 'react-router-dom';
import FloorPlan from './FloorPlan';

const BookingHome = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlMode = searchParams.get('mode'); // 'block' or 'individual'
  const urlDate = searchParams.get('date');

  const [mode, setMode] = useState(urlMode || null);

  useEffect(() => {
    if (urlMode) setMode(urlMode);
  }, [urlMode]);

  const handleBack = () => {
    setMode(null);
    setSearchParams({});
  };

  if (mode) {
    return (
      <Box>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
          sx={{ mb: 2, color: '#052e2b' }}
        >
          Back to Booking Options
        </Button>
        <FloorPlan bookingMode={mode} initialDate={urlDate} />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" fontWeight={600} sx={{ mb: 3, color: '#052e2b' }}>
        7th Floor - Seat Booking
      </Typography>
      <Grid container spacing={3} sx={{ alignItems: 'stretch' }}>
        <Grid size={6}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              height: '100%',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s',
              border: '2px solid transparent',
              '&:hover': {
                border: '2px solid #68DA6A',
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 24px rgba(5,46,43,0.15)',
              },
            }}
            onClick={() => setMode('block')}
          >
            <DateRangeIcon sx={{ fontSize: 48, color: '#052e2b', mb: 1.5 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: '#052e2b' }}>
              Block Booking
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Book seats for multiple days at once. Select a date range, then choose your seats.
            </Typography>
          </Paper>
        </Grid>
        <Grid size={6}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              height: '100%',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.2s',
              border: '2px solid transparent',
              '&:hover': {
                border: '2px solid #68DA6A',
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 24px rgba(5,46,43,0.15)',
              },
            }}
            onClick={() => setMode('individual')}
          >
            <EventSeatIcon sx={{ fontSize: 48, color: '#052e2b', mb: 1.5 }} />
            <Typography variant="h6" fontWeight={600} sx={{ color: '#052e2b' }}>
              Individual Day Booking
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Book seats for a single day. Pick a day and select your seats.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BookingHome;
